import { ClientTypes } from './actionTypes';

//Get clients

export const getClients = (data: {
  data?: any;
  pagination?: { sizePerPage: number; page: number };
}) => ({
  type: ClientTypes.GET_CLIENTS,
  data,
});

export const getClientsSuccess = (clients: any) => ({
  type: ClientTypes.GET_CLIENTS_SUCCESS,
  payload: clients,
});

export const getClientsFail = (error: any) => ({
  type: ClientTypes.GET_CLIENTS_FAIL,
  payload: error,
});

//Get clients Details

export const getClientsDetail = (clientId: number) => ({
  type: ClientTypes.GET_CLIENTS_DETAIL,
  clientId,
});

export const getClientsDetailSuccess = (clients: any) => ({
  type: ClientTypes.GET_CLIENTS_DETAIL_SUCCESS,
  payload: clients,
});

export const getClientsDetailFail = (error: any) => ({
  type: ClientTypes.GET_CLIENTS_DETAIL_FAIL,
  payload: error,
});

//ADD clients
export const addClients = (clientsAdd: any) => {
  return {
    type: ClientTypes.ADD_CLIENTS,
    payload: { clientsAdd },
  };
};

export const addClientsSuccess = (clientsAdd: any) => {
  return {
    type: ClientTypes.ADD_CLIENTS_SUCCESS,
    payload: clientsAdd,
  };
};

export const addClientsFail = (error: any) => {
  return {
    type: ClientTypes.ADD_CLIENTS_FAIL,
    payload: error,
  };
};

//DELETE CLient
export const deleteClients = (id: any) => {
  return {
    type: ClientTypes.DELETE_CLIENTS,
    payload: { id },
  };
};

export const deleteClientsSuccess = (payload: any) => {
  return {
    type: ClientTypes.DELETE_CLIENTS_SUCCESS,
    payload,
  };
};

export const deleteClientsFail = (error: any) => {
  return {
    type: ClientTypes.DELETE_CLIENTS_FAIL,
    payload: error,
  };
};

//UPDATE Clients
export const updateClients = (client: any) => {
  return {
    type: ClientTypes.UPDATE_CLIENTS,
    payload: { client },
  };
};

export const updateClientsSuccess = (client: any) => {
  return {
    type: ClientTypes.UPDATE_CLIENTS_SUCCESS,
    payload: client,
  };
};

export const updateClientsFail = (error: any) => {
  return {
    type: ClientTypes.UPDATE_CLIENTS_FAIL,
    payload: error,
  };
};
export const getBrandCustom = () => ({
  type: ClientTypes.GET_BRAND_CUSTOM,
});

export const getBrandCustomSuccess = (BrandCustom: any) => {
  return {
    type: ClientTypes.GET_BRAND_CUSTOM_SUCCESS,
    payload: BrandCustom,
  };
};

export const getBrandCustomFail = (error: any) => ({
  type: ClientTypes.GET_BRAND_CUSTOM_FAIL,
  payload: error,
});

export const updateImageClients = (file: any) => {
  return {
    type: ClientTypes.UPDATE_IMAGE_CLIENTS,
    payload: file,
  };
};

export const updateImageClientsSuccess = (file: any) => {
  return {
    type: ClientTypes.UPDATE_IMAGE_CLIENTS_SUCCESS,
    payload: file,
  };
};

export const updateImageClientsFail = (error: any) => {
  return {
    type: ClientTypes.UPDATE_IMAGE_CLIENTS_FAIL,
    payload: error,
  };
};


export const sendTestEmail = (testEmail: any) => {
  return {
    type: ClientTypes.SEND_TEST_EMAIL,
    payload: testEmail,
  };
};
export const sendTestEmailSuccess = (testEmail: any) => {
  return {
    type: ClientTypes.SEND_TEST_EMAIL_SUCCESS,
    payload: testEmail,
  };
};
export const sendTestEmailFail = (error: any) => {
  return {
    type: ClientTypes.SEND_TEST_EMAIL_FAIL,
    payload: error,
  };
};
